import React from 'react';

const TermsOfService = () => {
  return (
    <div className="max-w-5xl mx-auto w-full px-6">
      <div className="p-6 rounded-md border bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 text-gray-800 dark:text-gray-200">
        <h1 className="text-2xl font-bold mb-4">Terms of Service</h1>

        <h2 className="text-xl font-semibold mt-2 mb-2">1. Acceptance of Terms</h2>
        <p className="mb-4 text-left">
          By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
        </p>

        <h2 className="text-xl font-semibold mt-2 mb-2">2. Use License</h2>
        <p className="mb-4 text-left">
          Permission is granted to temporarily download one copy of the materials (information or software) on Borsai's website for personal, non-commercial transitory viewing only.
        </p>

        <h2 className="text-xl font-semibold mt-2 mb-2">3. Disclaimer</h2>
        <p className="mb-2 text-left">
          The materials on Borsai's website are provided on an 'as is' basis. Borsai makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
